import React from 'react';
import { motion } from 'framer-motion';

const Nosotros = () => (
  <section id="nosotros" style={{ padding: '4rem 1rem', background: '#e0f7fa' }}>
    <motion.div initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{ duration: 1 }}>
      <h2 style={{ textAlign: 'center' }}>Sobre Nosotros</h2>
      <p style={{ maxWidth: '700px', margin: '1rem auto', textAlign: 'center' }}>
        Somos una empresa dedicada a ofrecer soluciones integrales de ingeniería en distintas ramas industriales. 
        Nos enfocamos en calidad, innovación y mejora continua.
      </p>
    </motion.div>

    <motion.div initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{ duration: 1 }}>
      <h2 style={{ textAlign: 'center' }}>Misión</h2>
      <p style={{ maxWidth: '700px', margin: '1rem auto', textAlign: 'center' }}>
      Ofrecer servicios y soluciones eficientes, de calidad, oportunos a las diferentes industrias salvadoreñas
       con el fin de ser un socio y apoyo aliado de sus clientes para realización de sus diferentes actividades
      </p>
    </motion.div>

    <motion.div initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{ duration: 1 }}>
      <h2 style={{ textAlign: 'center' }}>Visión</h2>
      <p style={{ maxWidth: '700px', margin: '1rem auto', textAlign: 'center' }}>
      Ser una empresa reconocida a nivel nacional e internacional que ofrece soluciones reales e innovadoras, 
      que satisfaga las exigencias de sus clientes y lo que a su vez les permita crecer expandir y desarrollar 
      su potencial, como un aliado estratégico, sobrepasando sus expectativas.
      </p>
    </motion.div>

    <motion.div initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{ duration: 1 }}>
      <h2 style={{ textAlign: 'center' }}>Valores</h2>
      <p style={{ maxWidth: '700px', margin: '1rem auto', textAlign: 'center' }}>
        Respeto, Confianza, Calidad, Amabilidad, Buen servicio al cliente, Innovación.
      </p>
    </motion.div>
  </section>

  
);

export default Nosotros;
